import { TerminalBaseDataProvider } from './TerminalBaseDataProvider';
import { TerminalWebComponentSchema } from '../types';
import {IdentityProviderAuthorizationLocation} from '../constants';

export class TerminalNirvanaDataProvider extends TerminalBaseDataProvider {
  async getDataForView(): Promise<TerminalWebComponentSchema> {
    let response = await this.isIdpRequestAuthorized(this.dependencies.endpointId);

    if (typeof response !== 'boolean') {
      response = false;
    }

    return {
      isIdpRequestAuthorized: response,
      isMdrGracePeriod: this.dependencies.user?.isInMdrGracePeriod ?? false
    };
  }

  async checkFileExists(file) {
    return this.dependencies.api.clients.RemoteShellAudit.fileExists(file).toPromise();
  }

  async isIdpRequestAuthorized(endpointId) {
    return this.dependencies.api.clients.SecurityManager.isIdpRequestAuthorized(
      {
        resourceId: endpointId,
        fromLocation: IdentityProviderAuthorizationLocation.BROWSER
      }).toPromise();
  }
}
